import {
  IActiveFilterValues,
  IComponent,
  IFilter,
  IOption
} from '../Interface/Interface';

const compareAlphaNumeric = (a: any, b: any) =>
  `${a}`.localeCompare(`${b}`, undefined, {
    numeric: true,
    ignorePunctuation: true
  });

const compareByProp =
  (propName: string, compareFunc = compareAlphaNumeric) =>
  (a: any, b: any) =>
    compareFunc(a, b);

export const setOptionFiltersForComponent = (component: IComponent) => {
  component.filters = Object.values(
    component.options
      .map(({ attributes }) =>
        attributes.filter(({ identifier }) => identifier.startsWith('filter_'))
      )
      .flat()
      .reduce(
        (
          filters: { [key: string]: IFilter },
          { identifier, translated_title: title, values }
        ) => ({
          ...filters,
          [identifier]: {
            identifier,
            title,
            values: values.reduce(
              (values, { value, translated_value }) =>
                values[value]
                  ? values
                  : {
                      ...values,
                      [value]: {
                        value,
                        title: translated_value
                      }
                    },
              filters[identifier]?.values || {}
            )
          }
        }),
        {}
      )
  )
    .map((filter) => ({
      ...filter,
      values: Object.values(filter.values).sort(compareByProp('title'))
    }))
    .filter(({ values }) => values.length > 1)
    .sort(compareByProp('title'));
};

export const getFilteredOptions = (
  options: IOption[],
  filters: IActiveFilterValues | null
) => {
  if (filters === null) {
    return options;
  }
  const filterIdentifiers = Object.keys(filters);
  const filterValues: { [key: string]: any } = filterIdentifiers.reduce(
    (values, identifier) => ({
      ...values,
      [identifier]: filters[identifier].map(({ value }) => value)
    }),
    {}
  );
  return options.filter(
    (option) =>
      filterIdentifiers.filter((filterIdentifier) =>
        option.attributes.find(
          ({ identifier, values }) =>
            filterIdentifier === identifier &&
            values.some(({ value }) =>
              filterValues[filterIdentifier].includes(value)
            )
        )
      ).length === filterIdentifiers.length
  );
};
